var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "has-margin-top" }, [
    _c(
      "div",
      {
        staticClass: "bp-panel has-no-title",
        staticStyle: { "min-height": "auto" },
      },
      [
        _c("div", { staticClass: "panel-content" }, [
          _c(
            "div",
            {
              staticClass: "is-flex is-align-items-center",
              staticStyle: { gap: "10px" },
            },
            [
              _vm._l(_vm.locales, function (code) {
                return [
                  _c(
                    "button",
                    {
                      key: code,
                      staticClass: "homepage-language-flag",
                      class: { "is-selected": code === _vm.selectedLocale },
                      attrs: { title: _vm.localeNames[code] },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("buttonAction", {
                            action: "switchLocale",
                            element: code,
                          })
                        },
                      },
                    },
                    [
                      _c("gb-flag", {
                        attrs: {
                          code: _vm.getFlag(code),
                          size: "small",
                          iconPath: "/assets/img/flags/",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
              _vm._v(" "),
              _vm.selectedLocale !== "de_DE"
                ? _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("buttonAction", {
                            action: "retranslate",
                            element: _vm.selectedLocale,
                          })
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("translate"),
                      ]),
                      _vm._v(" Neu übersetzen\n                "),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.selectedLocale !== "de_DE"
            ? _c("p", { staticClass: "is-small-text mt-2" }, [
                _vm._v("\n                Du bearbeitest die Sprache: "),
                _c("b", [_vm._v(_vm._s(_vm.localeNames[_vm.selectedLocale]))]),
                _vm._v(
                  ". Änderungen werden nur für diese Sprache gespeichert.\n            "
                ),
              ])
            : _c("p", { staticClass: "is-small-text mt-2" }, [
                _vm._v(
                  "\n                Beim ersten Wechsel auf eine andere Sprache werden alle Homepage-Texte automatisch per KI übersetzt.\n            "
                ),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }